function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerLocaleKeys from '../../../locales/keys';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import { CustomerTotalsCollectionSelector, IsFetchingTotalsDataSelector, TotalsCountSelector } from '../../../reducers/selectors/customer.totals.selectors';
import { retrieveTransactionTotals } from '../../../reducers/actions/customer.totals.actions';
import { i18n } from 'invision-core';
var TotalsController = /*#__PURE__*/function () {
  function TotalsController($ngRedux) {
    _classCallCheck(this, TotalsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys
    });
  }
  return _createClass(TotalsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          isFetchingTotals: IsFetchingTotalsDataSelector(store),
          totals: CustomerTotalsCollectionSelector(store),
          totalsCount: TotalsCountSelector(store)
        };
      };
      var controllerActions = {
        retrieveTransactionTotals: retrieveTransactionTotals
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.columnDefs = [{
        field: 'Currency',
        displayName: i18n.translate(CustomerLocaleKeys.TOTALS.CURRENCY),
        cellTemplate: require('./cellTemplates/currency.type.html')
      }, {
        field: 'GrossAmount',
        displayName: i18n.translate(CustomerLocaleKeys.TOTALS.ORIGINAL_AMOUNT),
        cellTemplate: require('./cellTemplates/original.amount.html')
      }, {
        field: 'CreditAmount',
        displayName: i18n.translate(CustomerLocaleKeys.TOTALS.CREDITS),
        cellTemplate: require('./cellTemplates/credit.amount.html')
      }, {
        field: 'WriteOffAmount',
        displayName: i18n.translate(CustomerLocaleKeys.TOTALS.WRITE_OFFS),
        cellTemplate: require('./cellTemplates/write.off.html')
      }, {
        field: 'NetAmount',
        displayName: i18n.translate(CustomerLocaleKeys.TOTALS.NET_AMOUNT),
        cellTemplate: require('./cellTemplates/net.amount.html')
      }];
      this.stateOrName = 'index.customercare.customer.totals';
      if (!this.state.totals) {
        this.actions.retrieveTransactionTotals(this.state.currentCustomerId);
      }
    }
  }]);
}();
export default {
  template: require('./totals.html'),
  controller: TotalsController,
  controllerAs: 'Totals'
};